import IItemOrderStatusViewModel from "interfaces/IItemOrderStatusViewModel";
import { useStateMachine } from "little-state-machine";
import { Link } from "react-router-dom";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { RolesEnum } from "modules/rolesEnum";
import { PencilSquare } from "react-bootstrap-icons";
import IEditItemOrderRequestModel from "interfaces/Request/IEditItemOrderRequestModel";
import { updateEditItemOrderPageOrigination } from "actions/updateEditItemOrderPageOrigination";

const EditTemplate = ({
  id,
  hwrcSiteId,
  orderType,
  item,
  recipient,
  quantity,
  size,
  status
}: IItemOrderStatusViewModel): any => {
  const { state, actions } = useStateMachine({ updateEditItemOrderPageOrigination });

  const editData : IEditItemOrderRequestModel = {
    id,
    hwrcSiteId,
    orderType,
    item,
    recipient,
    quantity,
    size,
    status
  };

  const editUrl = encodeURI(`${RoutePathsEnum.ItemOrdersEdit}`);

  const handleContextMenu = (event:any) => {
    event.preventDefault();
  };

  const handleNavigate = () => {
    actions.updateEditItemOrderPageOrigination(RoutePathsEnum.ItemOrders);
  };

  return ((["Raised", "Actioned"].includes(status) || [RolesEnum.SuperAdmin, RolesEnum.Admin].includes(state.userRole!))
    ? (
      <div className="d-flex justify-content-center">
        <Link state={editData} to={editUrl} onClick={handleNavigate} onContextMenu={handleContextMenu}>
          <PencilSquare color="#000" size={32} />
          <span className="visually-hidden">
            {`Edit ${item} item order`}
          </span>
        </Link>
      </div>
    ) : <></>
  );
};
export default EditTemplate;
